<template>
  <SOSlotModal
      :modal-id="id"
      modal-title="Stiker QRIS"
      @close="close"
  >
    <template v-slot:modal-body>
      <div class="qr-wrapper">
        <img :src="urlQr" style="height: 50vh">
      </div>
    </template>
    <template v-slot:modal-footer>
      <SOButton
          text="Download Stiker QRIS"
          :full="true"
          :outline="true"
          @action="download"
      />
    </template>
  </SOSlotModal>
</template>

<script>
import SOSlotModal from "@/so-components/global/slot/SOSlotModal";
import SOButton from "@/so-components/global/ui/SOButton";
import VueQr from "vue-qr-generator"

export default {
  name: "SnapMesinModalQr",
  components: {SOButton, SOSlotModal, VueQr},
  props: {
    qr: String,
	  namaMesin: String,
	  urutan: String,
	  jenis: String,
	  idMesin:String
  },
  data() {
    return {
      id: "modal-qr",
      loading: false,
      urlQr: "",
	    channel:(this.qr.includes("LINKAJA")) ? "Xendit" : "Nobu"
    }
  },
  methods: {
    close() {
      $("#" + this.id).modal("hide");
      setTimeout(() => {
        this.$emit("close")
      }, 500)
    },
    download() {
      const link = document.createElement('a')
      link.href =  "https://central-kube.smartlink.id/smartlink_qr/download?text=" +this.qr+
	      "&label="+this.namaMesin+
	      "&kode=" +this.urutan+
	      "&channel="+this.channel+
	      "&idmesin=" +this.idMesin+
	      "&tipe=" +(this.jenis=="1" ? "washer": "dryer")
      document.body.appendChild(link)
      link.click()
      this.flutterDownload(link.href)
      document.body.removeChild(link)
    }
  },
  mounted() {
    $("#" + this.id).modal("show")
    this.urlQr = "https://central-kube.smartlink.id/smartlink_qr/view?text=" +this.qr+
	    "&label="+this.namaMesin+
	    "&idmesin="+this.idMesin+
	    "&channel="+this.channel+
    "&kode=" +this.urutan+
    "&tipe=" +(this.jenis==1 ? "washer": "dryer")
    console.log(this.urlQr)
  }
}
</script>

<style scoped>
.qr-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: -1rem;
}
</style>